export default "__VITE_ASSET__CVBc_1QI__"